export const extractErrorMessage = (error) => {
  const message =
    error?.response?.data?.details[0] ||
    error?.response?.data?.details ||
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong";

  if (!message) {
    return;
  }

  return message;
};
